var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      minWidth: 18
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1616 2.92175C9.01618 2.92175 6.45989 5.47804 6.45989 8.62351V11.3699C6.45989 11.9495 6.21282 12.8333 5.91823 13.3275L4.82539 15.1425C4.15068 16.2639 4.61632 17.5087 5.85171 17.9269C9.94747 19.2953 14.3663 19.2953 18.4621 17.9269C19.6119 17.5468 20.1156 16.1878 19.4884 15.1425L18.3956 13.3275C18.1105 12.8333 17.8634 11.9495 17.8634 11.3699V8.62351C17.8634 5.48754 15.2976 2.92175 12.1616 2.92175Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1621 1.12L2.16211 21.12",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9204 3.19737C13.6258 3.11184 13.3217 3.04532 13.0081 3.00731C12.0958 2.89328 11.2215 2.9598 10.4043 3.19737C10.6799 2.49415 11.3641 2 12.1623 2C12.9606 2 13.6448 2.49415 13.9204 3.19737Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0133 18.2692C15.0133 19.8371 13.7304 21.12 12.1624 21.12C11.3832 21.12 10.6609 20.7969 10.1478 20.2838C9.63462 19.7706 9.31152 19.0484 9.31152 18.2692",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMute);
export default __webpack_public_path__ + "static/media/IconMute.96e40d4bef6139c580977890083521ac.svg";
export { ForwardRef as ReactComponent };